<template>
  <div class="vx-card">
    <div class="vx-card__body card-body">
      <div class="vx-row mb-6">
        <div class="vx-col w-full mb-2">
          <vs-button
            @click="createProductSegment()"
            class="bg_l_green"
            v-has-permission="permission35"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
            {{ $t("CreateNewProductSegment") }}
          </vs-button>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          <data-grid
            ref="grid"
            stripe
            :data-source="gridDataSource"
            :search-data="gridSearchData"
            :columns="[
              { title: $t('Title'), sort: 'Name' },
              { title: $t('SegmentId') },
              { title: $t('CreateOn'), sort: 'CreateOn' },
              { title: $t('Action') },
            ]"
          >
            <template slot-scope="{ row }">
              <td style="width: 30%">
                {{ row.name }}
              </td>
              <td style="width: 9%">
                {{ row.id }}
              </td>
              <td style="width: 30%; direction: ltr">
                {{ row.createOn.split(" ")[0] }}<br />{{
                  row.createOn.split(" ")[1]
                }}
              </td>
              <td style="width: 30%; text-align: right !important">
                <div class="flex gap-2 w-full justify-center items-center">
                  <vs-button
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    icon="icon-edit"
                    class="bordered-btn mx-0"
                    @click.prevent="productPopup(row)"
                    v-has-permission="permission38"
                    >{{ $t("Products") }}</vs-button
                  >
                  <vs-button
                    v-if="row.id != 3"
                    radius
                    color="success"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-edit"
                    @click.prevent="editSegment(row)"
                    class="d-inline"
                    v-has-permission="permission36"
                  ></vs-button>
                  <vs-button
                    v-if="row.id != 3"
                    radius
                    color="danger"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-x"
                    @click.prevent="deleteSegment(row.id)"
                    class="d-inline"
                    v-has-permission="permission37"
                  ></vs-button>
                </div>
              </td>
            </template>
          </data-grid>
        </div>
      </div>
      <modify-popup
        :show="ModifyPopup"
        :model="modalModel"
        @finish="onfinish"
        @close="closeModifyPopup"
      ></modify-popup>
      <product-popup
        :show="showProductPopup"
        :productModalModel="productModalModel"
        @finish="onProductModalfinish"
      ></product-popup>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import ModifyPopup from "./ModifyPopup.vue";
import ProductPopup from "./ProductPopup.vue";
export default {
  name: "saleManagement_BasicDefinitions_productSegment_Index",

  components: {
    ModifyPopup,
    DataGrid,
    ProductPopup,
  },
  data() {
    return {
      permission35: "CreateSegment",
      permission36: "ModifySegment",
      permission37: "RemoveSegment",
      permission38: "GetAllProductInfos",
      ModifyPopup: false,
      modalModel: {},
      itemList: [],
      gridDataSource: {
        type: "app",
        service: "Sales/api/SegmentQuery",
      },
      gridSearchData: {},
      showProductPopup: false,
      productModalModel: {},
    };
  },
  computed: {
    ...mapGetters({
      allSegments: "",
    }),
  },
  methods: {
    ...mapActions({
      removeSegment: "productSegment/remove",
    }),
    ////Open Modal In Create Mode
    createProductSegment() {
      this.modalModel = {};
      this.ModifyPopup = true;
    },
    //Open Modal In Edit Mode
    editSegment(model) {
      this.modalModel = {
        segmentId: model.id,
        name: model.name,
      };
      this.ModifyPopup = true;
    },
    //Delete Method
    deleteSegment(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removeSegment(id).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
    closeModifyPopup() {
      this.ModifyPopup = false;
    },
    onfinish() {
      this.closeModifyPopup();
      this.$refs.grid.renderGrid();
    },
    productPopup(model) {
      this.productModalModel = {
        segmentId: model.id,
      };
      this.showProductPopup = true;
    },
    onProductModalfinish() {
      this.showProductPopup = false;
    },
  },
};
</script>
